import React, { type ChangeEvent, useCallback } from 'react';

import { styled } from '@compiled/react';
import { Checkbox } from '@atlaskit/checkbox';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';

export type Props = {
	onChange: (value: boolean) => void;
	value: boolean;
};

export const CreateReleaseNotesPrompt = ({ onChange, value }: Props) => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onValueChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			fireUIAnalytics(
				createAnalyticsEvent({
					action: 'toggled',
					actionSubject: 'checkbox',
				}),
				'releaseModalCreateReleaseNotesCheckbox',
			);
			onChange(event.target.checked);
		},
		[createAnalyticsEvent, onChange],
	);

	return (
		<Wrapper>
			<Checkbox
				name="createReleaseNotes"
				label={formatMessage(messages.createReleaseNotesTitle)}
				isChecked={value}
				onChange={onValueChange}
			/>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
});
